import { render } from "./ConcursSingle.vue?vue&type=template&id=9c9f8b92&scoped=true"
import script from "./ConcursSingle.vue?vue&type=script&lang=js"
export * from "./ConcursSingle.vue?vue&type=script&lang=js"

import "./ConcursSingle.vue?vue&type=style&index=0&id=9c9f8b92&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9c9f8b92"]])

export default __exports__